import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";

const KEY = "rc-cookie-consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(KEY);
    if (!stored) {
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (value) => {
    localStorage.setItem(KEY, value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
          data-testid="cookie-banner"
          className="fixed bottom-6 left-6 right-6 sm:right-auto z-[60] max-w-md bg-brand-ink text-white rounded-2xl shadow-2xl border border-white/10 p-6"
        >
          <div className="flex items-start gap-3 mb-4">
            <div className="w-10 h-10 rounded-xl bg-brand-gold/15 flex items-center justify-center flex-shrink-0">
              <Cookie className="text-brand-gold" size={20} />
            </div>
            <div>
              <h3 className="font-display font-bold text-base mb-1">Questo sito utilizza i cookie</h3>
              <p className="text-white/60 text-sm leading-relaxed">
                Utilizziamo cookie tecnici e, previo consenso, cookie funzionali per migliorare la tua esperienza.
                Consulta la{" "}
                <a href="/cookie-policy" target="_blank" rel="noreferrer" data-testid="cookie-banner-policy-link" className="text-brand-gold font-semibold underline">Cookie Policy</a>.
              </p>
            </div>
          </div>
          <div className="flex gap-3">
            <button
              data-testid="cookie-accept-btn"
              onClick={() => decide("accepted")}
              className="flex-1 bg-brand-gold hover:bg-brand-goldDark text-brand-ink font-bold py-2.5 rounded-full transition-colors text-sm"
            >
              Accetta
            </button>
            <button
              data-testid="cookie-reject-btn"
              onClick={() => decide("rejected")}
              className="flex-1 border border-white/25 hover:border-white text-white font-semibold py-2.5 rounded-full transition-colors text-sm"
            >
              Rifiuta
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
